import { Observable, of, tap } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AuthService } from '@admin/auth/services/auth.service';
import { AuthService as SociuuhubAuthService } from '@sociuuhub/modules/auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SociuuhubGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private sociuuhubAuthService: SociuuhubAuthService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    this.authService.isSociuuhub = true;

    // Check if become user session has expired
    if (this.authService.isBecomeUserEnabled && this.isBecomeUserSessionExpired()) {
      this.handleExpiredSession();
      return of(false);
    }

    return of(this.authService.isSociuuhub)
      .pipe(
        tap((response: boolean): void => {
          if (!response) this.router.navigate(['/login']);
        })
      );
  }

  private isBecomeUserSessionExpired(): boolean {
    const expireTimeString = localStorage.getItem('becomeUserExpireTime');

    if (!expireTimeString) {
      return true; // No expiration time means session is invalid
    }

    const expireTime = parseInt(expireTimeString, 10);
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds (epoch)

    return currentTime >= expireTime;
  }

  private handleExpiredSession(): void {
    console.log('Become user session has expired, logging out...');

    // Clean up localStorage
    localStorage.removeItem('tokenUser');
    localStorage.removeItem('isBecomeUser');
    localStorage.removeItem('becomeUserByTypeID');
    localStorage.removeItem('becomeUserExpireTime');

    // Log out from sociuuhub
    this.sociuuhubAuthService.logout();
  }
}
